/**
 * Hier sind einige Daten und Hilfsfunktionen die beim Upgrade unterstützen sollen.
 */
function ixTryConsoleError() {
    try {
        console && console.error && console.error.apply(null, arguments);
    } catch (e) {}
}

function ixTryConsoleLog() {
    try {
        console && console.log && console.log.apply(null, arguments);
    } catch (e) {}
}

function ixTryConsoleWarn() {
    try {
        console && console.warn && console.warn.apply(null, arguments);
    } catch (e) {}
}

var ixUpgradeUtil = {
    isNonEmptyString: function (str) {
        return str && typeof str === "string";
    },
    isObject: function (obj) {
        return obj && typeof obj === "object" && !Array.isArray(obj);
    },
};

/**
 *
 */
var ixUpgrade = (function () {
    // Für Angular-Services
    var ixUpgradeAngularServices = {};

    // Für ImpactX-Services
    var ixUpgradeImpactXServices = {};

    // Für Angular-Callbacks
    var ixUpgradeImpactXServiceCallbacks = {};

    var ixUpgrade = {
        ixaUpgrade: null,
        extendToolbarItems: function (buttonDefinition) {
            if (this.ixaUpgrade) {
                this.ixaUpgrade.extendToolbarItems(buttonDefinition);
            }
        },
        /**
         * Erweitert die Menüeinträge.
         *
         * @param {object} workspace
         */
        extendWorkspaceMenuItems: function (workspace) {
            if (this.ixaUpgrade) {
                this.ixaUpgrade.extendWorkspaceMenuItems(workspace);
            }
        },
        getUpgradeConfigurations: function () {
            if (this.ixaUpgrade) {
                return this.ixaUpgrade.getUpgradeConfigurations();
            }
            return [];
        },
        isStorageSupported: function () {
            if (this.ixaUpgrade) {
                return this.ixaUpgrade.isStorageSupported();
            }
            return false;
        },
        setUpgradeConfigurationInStorage: function (config) {
            if (this.ixaUpgrade) {
                return this.ixaUpgrade.setUpgradeConfigurationInStorage(config);
            }
            return false;
        },
        getAngularService: function (serviceName) {
            if (
                ixUpgradeUtil.isNonEmptyString(serviceName) &&
                ixUpgradeAngularServices[serviceName]
            ) {
                return ixUpgradeAngularServices[serviceName];
            }
            return null;
        },
        getImpactXService: function (serviceName) {
            if (
                ixUpgradeUtil.isNonEmptyString(serviceName) &&
                ixUpgradeImpactXServices[serviceName]
            ) {
                return ixUpgradeImpactXServices[serviceName];
            }
            return null;
        },

        registerAngularService: function (serviceName, service) {
            if (
                ixUpgradeUtil.isNonEmptyString(serviceName) &&
                ixUpgradeUtil.isObject(service)
            ) {
                ixUpgradeAngularServices[serviceName] = service;
                ixTryConsoleLog("ANGULAR:Service registered: ", serviceName);
            }
        },
        registerImpactXService: function (serviceName, service) {
            if (ixUpgradeUtil.isNonEmptyString(serviceName) && service) {
                ixUpgradeImpactXServices[serviceName] = service;
                if (
                    ixUpgradeUtil.isObject(
                        ixUpgradeImpactXServiceCallbacks[serviceName]
                    )
                ) {
                    ixUpgradeImpactXServiceCallbacks[serviceName].callback();
                    ixUpgradeImpactXServiceCallbacks[serviceName].called = true;
                }
            }
        },
        waitForImpactXService: function (serviceName, callback) {
            if (
                ixUpgradeUtil.isNonEmptyString(serviceName) &&
                typeof callback === "function"
            ) {
                ixUpgradeImpactXServiceCallbacks[serviceName] = {
                    callback: callback,
                    called: false,
                };

                if (ixUpgradeImpactXServices[serviceName]) {
                    callback();
                    ixUpgradeImpactXServiceCallbacks[serviceName].called = true;
                }
            } else {
                ixTryConsoleError(
                    "registerAngularForImpactXService: wrong parameters: ",
                    serviceName,
                    callback
                );
            }
        },
    };

    return ixUpgrade;
})();
